const required = (value: any): boolean => {
  if (typeof value === 'number') {
    return true
  }

  return value?.length > 0
}

export default required
